import { FilterActions, FilterVariant } from "@next-platform/client-common-spicy-ui";
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

import { normalizeLanguageName } from "@/utils/normalizeLanguageName";

const toVariant = ({ isRefined, isExcluded }: { isRefined?: boolean; isExcluded?: boolean }) => {
  if (isExcluded) return FilterVariant.EXCLUDE;
  if (isRefined) return FilterVariant.INCLUDE;
  return FilterVariant.DEFAULT;
};

export const generateLanguageData = function (
  items: RefinementListItem[],
  actionHandler: (action: FilterActions, value?: string) => void,
  translateLabel: (normalizedDisplayLabel: string) => string,
) {
  const sorted = items.slice().sort((itemA, itemB) => {
    if ((itemB.count ?? 0) !== (itemA.count ?? 0)) return (itemB.count ?? 0) - (itemA.count ?? 0);
    return normalizeLanguageName(itemA.label).localeCompare(normalizeLanguageName(itemB.label));
  });

  return sorted.map((refinementListItem) => {
    const label = translateLabel(normalizeLanguageName(refinementListItem.label));
    const count = refinementListItem.count ?? 0;
    return {
      label,
      count,
      value: refinementListItem.value,
      variant: toVariant(refinementListItem),
      disabled: count === 0,
      actionHandler,
    };
  });
};
